import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ReduxStates } from '../../redux/reduxTypes';
import { Redirect } from 'react-router-dom';

import { ReactComponent as BreadCrumbIcon } from '../../assets/icons/breadcrumb-icon.svg';
import DataUpload from './components/DataUpload';
import DataMapping from './components/DataMapping';
import { Status as StatusInterface } from '../../types';

import { typeStyles } from './config';
import Status from '../../components/Status';
import { Link } from 'react-router-dom';

interface Props {
  isMapping: boolean;
}

const DataManagement = ({ isMapping }: Props): any => {
  const copyData = useSelector((state: ReduxStates) => state.copyData);
  const userInfo = useSelector((state: ReduxStates) => state.user);
  const [status, setStatus] = useState<StatusInterface | null>(null);

  useEffect(() => {
    if (status !== null) {
      setTimeout(() => {
        setStatus(null);
      }, 5000);
    }
  }, [status]);

  const [showMapping] = useState<boolean>(isMapping);

  // set document title
  document.title = 'Data Management - Ascential Connect';

  return userInfo.userModules && userInfo.userModules.includes('Upload Data') ? (
    <div className="pt-[30px] px-6 relative pb-[43px]">
      {status && <Status state={status.state} message={status.message} onExit={() => setStatus(null)} />}
      <div className="flex justify-between mt-1 mb-2.5 py-[21px] px-0 pb-0">
        <div className="flex items-center text-center">
          <div className="flex items-center mr-3">
            <p className="flex items-center gap-x-3 text-[#898989] font-nunitoRegular">
              <span>{copyData?.account_title}</span>
              <BreadCrumbIcon className="my-0 mx-[5px] mb-1 relative top-[2px] fill-current text-[#898989]" />
              <span>{copyData?.data_management_title}</span>
            </p>
          </div>
        </div>
      </div>
      <div className="bg-[rgba(118,118,128,0.12)] rounded w-[236px] p-[3px]">
        <div className={`flex justify-between items-center h-full`}>
          <Link
            role="button"
            id="scratchpad_toggle-button_multimetric"
            className={`${typeStyles} ${
              !showMapping && 'bg-white text-navy border-[0.5px] border-[rgba(0,0,0,0.04)] shadow-scratchpadTypeShadow'
            }`}
            to="/account/data-management"
          >
            {copyData?.data_upload_title}
          </Link>
          <Link
            role="button"
            id="scratchpad_toggle-button_slicer"
            className={`${typeStyles} ${
              showMapping && 'bg-white text-navy border-[0.5px] border-[rgba(0,0,0,0.04)] shadow-scratchpadTypeShadow'
            }`}
            to="/account/data-management/mapping"
          >
            {copyData?.data_mapping_title}
          </Link>
        </div>
      </div>
      {showMapping ? <DataMapping setStatus={setStatus} /> : <DataUpload setStatus={setStatus} />}
    </div>
  ) : (
    userInfo.userModules && <Redirect to="/glance" />
  );
};

export default DataManagement;
